import { useButton } from 'ui-components';

export const SkipToMainButton = ({
  label = 'Skip to main content',
}: {
  label?: string;
}) => {
  const { buttonClassNames } = useButton({
    hasArrow: false,
    style: 'primary',
    size: 'small',
    label,
    className: 'absolute -top-48 left-8 z-overlay focus:top-4',
    isDarkMode: false,
  });
  const handleClick = (event?: React.MouseEvent<HTMLAnchorElement>) => {
    event?.preventDefault();
    const main = document.getElementById('main');
    if (main) {
      main.tabIndex = -1;
      main.focus();
    }
  };
  return (
    <a
      href="#main"
      className={buttonClassNames}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          handleClick();
        }
      }}
      aria-label={label}
    >
      {label}
    </a>
  );
};
